import { useEffect } from "react";

// Mounted only in BuildHostRoutes. Opt in per build; other portals retain their metadata.
export function BuildAppMetadata() {
  useEffect(() => {
    if (process.env.REACT_APP_BUILD_PWA !== "true") return undefined;
    const manifest = document.createElement("link");
    manifest.rel = "manifest";
    manifest.href = `${process.env.PUBLIC_URL || ""}/build-app.webmanifest`;
    const icon = document.querySelector('link[rel="apple-touch-icon"]');
    const previousIcon = icon?.getAttribute("href");
    if (icon) icon.setAttribute("href", `${process.env.PUBLIC_URL || ""}/brand/build-app-192.png`);
    document.head.appendChild(manifest);
    return () => {
      manifest.remove();
      if (icon && previousIcon !== null) icon.setAttribute("href", previousIcon);
    };
  }, []);
  return null;
}
